import dataRoamingApi from "../../api/dataRoaming/dataRoamingApi";
import event from '@/event-bus/event';

export default {
	name: '',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
			roamSIMType: '',
			voiceBasic: { applyStatusARW: '', applyStatusCDW: ''},
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async init() {
			this.roamSIMType = await dataRoamingApi.getRoamSIMType();
			this.voiceBasic = await dataRoamingApi.retrieveVoiceBasicStatus4Roaming();
		},

		async changeVoiceBasicStatus4Roaming(ServiceID, applyStatus) {

			// SIM卡種類為Single，並且啟用漫遊
			if (this.roamSIMType == 'S' && applyStatus == 'D') {
				const countryRoamItem = {
					serviceID: ServiceID,
					applyStatusARW: this.voiceBasic.applyStatusARW,
					applyStatusCDW: this.voiceBasic.applyStatusCDW
				}
				this.$bus.$emit(event.countryRoamingAlert, countryRoamItem, null, null);
			} else {
				let res = await dataRoamingApi.changeVoiceBasicStatus4Roaming(ServiceID, this.voiceBasic.applyStatusARW,this.voiceBasic.applyStatusCDW);
				if (res) {
					this.$router.push({ name: 'gt-success', params: { title: '國際語音漫遊服務', msg: '國際語音漫遊服務已設定成功', returnName: 'voice-roaming' } });
				}
			}

		}
	},
};



// WEBPACK FOOTER //
// ./src/components/dataRoaming/voiceRoaming.js